/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Scrollbars } from "react-custom-scrollbars";
import makeAnimated from "react-select/animated";
import Select from "react-select";
//components
import ClideLoader from "app/shared/ui-kit/loader";
import { useTranslation } from "react-i18next";
//assets
import {
  PlusIconRed,
  RoundSave,
  CrossRound,
  RoundDelete,
  RoundEdit,
} from "assets/Iconsv2/Iconsv2";
const animatedComponents = makeAnimated();
const DetailStep1 = ({ state, functionContent, variablesObj }) => {
  const {t} = useTranslation(['ira','util']);
  const { isInprogress, isApproveEnabled, iraDetailStep1 } = variablesObj ?? {};

  return (
    <div>
      
      <div className="row mt-3">
        <div className="col-12 col-md-12 col-lg-12">
          <div className="col-12 col-lg-12 col-md-12 d-flex justify-content-between px-0">
            <div className="clide-v2-title mb-1">
              <label className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-4">
                {" "}
                {t('initialResponse')}
              </label>
            </div>
            <div className="d-flex align-items-center">
              {/* Search Bar */}
              {/* <div className="input-group me-3" style={{ width: '300px' }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t('searchByInitialResponse')}
                  aria-label="Search"
                  aria-describedby="button-addon2"
                  value={state.initialResponseSearchText || ''}
                  onChange={(e) =>
                    functionContent.setState({
                      initialResponseSearchText: e.target.value
                    })
                  }
                />
                <button
                  className="btn btn-secondary clide-v2-bg-white clide-v2-border-color border-start-0"
                  type="button"
                  id="button-addon2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={20}
                    height={20}
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill="#F56620"
                      d="M8.333 3.334a5 5 0 100 10 5 5 0 000-10zm-6.666 5A6.667 6.667 0 1113.6 12.422l4.49 4.49a.833.833 0 01-1.18 1.178l-4.488-4.49A6.667 6.667 0 011.667 8.334z"
                    ></path>
                  </svg>
                </button>
              </div> */}
              {isInprogress && isApproveEnabled && !iraDetailStep1?.length ? (
                <button
                  className="clide-v2-icon-btn "
                  onClick={() =>
                    functionContent.debounceFunc(() => {
                      functionContent.setState({
                        addIntialResponse: true,
                      });
                    })
                  }
                >
                  <PlusIconRed />
                </button>
              ) : null}
            </div>
          </div>

          
            {state.addIntialResponse ? (
             <div className="border p-2 rounded row w-100">
                <div className="col-12 col-lg-10 col-md-10">
                  <div class="slds-form-element slds-has-error">
                    <label
                      class="fs-6 slds-m-bottom_xx-small "
                      for="form-element-05  "
                    >
                      
                      {t('addInitialResponse')}
                      <abbr class="slds-required" title={t('required')}   style={{ textDecoration: "none", borderBottom: "none" }}
                      >
                        *{" "}
                      </abbr>
                    </label>
                    <div class="slds-form-element__control">
                      <input
                        type="text"
                        id="form-element-05"
                        className="form-control"
                        value={state.initialResponse.description}
                        onChange={(e) =>
                          functionContent.setState({
                            initialResponse: {
                              ...state.initialResponse,
                              description: e.target.value,
                            },
                          })
                        }
                        placeholder={t('enterInitialResponse')}
                      />
                    </div>
                    {/* <div class="slds-form-element__help" id="form-error-01">Enter a value.</div> */}
                  </div>
                  <div>
                    <label class="fs-6" for="select-01">
                     
                      {t("action")}  <abbr class="slds-required" title="required"   style={{ textDecoration: "none", borderBottom: "none" }}
                      >
                        *{" "}
                      </abbr>
                    </label>
                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      minHeight="100"
                      isMulti
                      value={state.initialResponse.actions}
                      options={state.actionsmaster ?? []}
                      onChange={(el) => {
                        console.log(el);
                        functionContent.setState({
                          initialResponse: {
                            ...state.initialResponse,
                            actions: el,
                          },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-2 col-md-2">
                  <div className="d-flex space-between justify-content-end mt-2">
                    {state.initialResponse.isLoading ? (
                      <div className=" mx-3 mt-3">
                        <ClideLoader />{" "}
                      </div>
                    ) : (
                      <div>
                        <button
                          className="cursor-p  clide-v2-icon-btn"
                          onClick={() =>
                            functionContent.debounceFunc(() => {
                              functionContent._initialresponseAdd();
                            })
                          }
                        >
                          <RoundSave className="cursor-p " />
                        </button>
                        <button
                          className="cursor-p mx-2 clide-v2-icon-btn"
                          onClick={() =>
                            functionContent.debounceFunc(() => {
                              functionContent.resetIntialParams();
                            })
                          }
                        >
                          <CrossRound />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
            {!state.addIntialResponse ? (
              <>
                {iraDetailStep1?.map((el, idx) => (
                  <div className="border p-2 rounded row w-100">
                    <div className="col-12 col-lg-9 col-md-9" key={idx}>
                      
                      <div class="clide-v2-title mb-1">
                              <label class="clide-v2-fs-4 fw-normal w-space-nobreak">
                              {el?.initial_response}
                              </label>
                            </div>
                      <div className=" d-flex flex-column">
                        <span className="   font-16 common-black-1 font-weight-500 my-2">
                          {t('action')} :
                        </span>
                        <Scrollbars
                          style={{
                            height: "2.8rem",
                            width: 'calc(100% - 10%)'
                          }}
                          renderView={(props) => (
                            <div
                              style={{
                                paddingRight: "15px",
                                ...props.style,
                                overflowX: "hidden",
                              }}
                            />
                          )}
                        >
                          <div className="d-flex">
                            {el.action_taken?.map((sub, i) => (
                              <span
                                key={i}
                                className="slds-badge px-3 py-2 font-weight-500 slds-badge_lightest mr-3"
                              >
                                {sub.action}
                              </span>
                            ))}
                          </div>
                        </Scrollbars>
                      </div>
                    </div>
                    <div className="col-12 col-lg-3 col-md-3">
                      <div className="d-flex space-between mt-2 justify-content-end">
                        {isInprogress && isApproveEnabled ? (
                          <div>
                            <button
                              onClick={() =>
                                functionContent.debounceFunc(() => {
                                  functionContent.setState({
                                    addIntialResponse: true,
                                    initialResponse: {
                                      editId: el?.initial_response_id,
                                      description: el?.initial_response,
                                      actions: el?.action_taken?.map((sub) => {
                                        return {
                                          value: sub?.id,
                                          label: sub?.action,
                                        };
                                      }),
                                    },
                                  });
                                })
                              }
                              className="clide-v2-icon-btn mr-2"
                            >
                              <RoundEdit />
                            </button>
                          </div>
                        ) : null}
                        {isInprogress && isApproveEnabled ? (
                          <div>
                            <button
                              onClick={() =>
                                functionContent.debounceFunc(() => {
                                  functionContent.manageDataGatheringParams(
                                    "",
                                    {
                                      isDeleteEnable: true,
                                      parameters: {
                                        initial_response_id:
                                          el?.initial_response_id,
                                      },
                                      stepNo: "step1",
                                    },
                                    false,
                                    "deleteParams"
                                  );
                                })
                              }
                              className="clide-v2-icon-btn mr-2"
                            >
                              <RoundDelete />
                            </button>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : null}
          
        </div>
      </div>
    </div>
  );
};

export default DetailStep1;
